module.exports = __webpack_public_path__ + "img/botonPanico.709526cf.svg";